// Client portal: set up payouts. When the business offers cashouts from the
// client balance, the client verifies their identity and bank on a
// Stripe-hosted page (Stripe Express; no separate Stripe password needed).
import React, { useCallback, useEffect, useState } from 'react';
import portalAPI from './portalApi';
import { formatApiError } from '../../utils/errorMessage';

const TEXT = {
  not_set_up: 'Set up payouts to receive money from your balance straight to your bank.',
  pending: 'Payout setup is not finished yet. Stripe may need a few more details.',
  active: 'Payouts are set up.',
};

export default function PortalPayouts() {
  const [state, setState] = useState(null);
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);
  const load = useCallback(async () => {
    try { setState((await portalAPI.payoutAccount()).data); } catch (e) { setState(null); }
  }, []);
  useEffect(() => { load(); }, [load]);
  if (!state || (!state.available && state.status === 'not_set_up')) return null;
  const start = async () => {
    setBusy(true); setError('');
    try { window.location.assign((await portalAPI.payoutOnboard()).data.url); } catch (e) { setError(formatApiError(e, 'Could not open the payout setup page')); }
    setBusy(false);
  };
  return (
    <section aria-label="Payouts" className="border rounded p-3 text-sm space-y-2">
      <h2 className="font-semibold">Payouts</h2>
      <p>{TEXT[state.status] || TEXT.pending}</p>
      {state.available && state.status !== 'active' && (
        <button type="button" disabled={busy} className="border rounded px-3 py-1" onClick={start}>
          {state.status === 'not_set_up' ? 'Set up payouts' : 'Finish payout setup'}
        </button>
      )}
      {error && <p role="alert" className="text-red-600 text-xs">{error}</p>}
    </section>
  );
}
